package co.maytes.standupbot.dashboard.features.settings

import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.minus
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Duration.Companion.days

object RetentionCopy {
    val rawActivityChoices: List<Int> = listOf(7, 14, 30, 60, 90)

    const val RAW_ACTIVITY_HINT =
        "Linear and GitHub activity, and the prompts and replies sent to Claude, are removed this long " +
            "after each standup. Summaries and standup text are kept."

    const val DELETE_DESCRIPTION =
        "Signs everyone out, stops every standup and permanently deletes the workspace after 30 days, " +
            "including standups, summaries, integration tokens and audit entries. Reinstall StandupBot " +
            "from Slack within those 30 days to keep it. Download an export first if you need the data."

    const val UNINSTALL_DESCRIPTION =
        "Signs everyone out. Standup history and integration tokens are kept, and reinstalling " +
            "StandupBot from Slack brings everything back."

    fun rawActivityLabel(days: Int): String = "$days days"

    fun deletionConfirmBody(): String =
        "Everyone is signed out and nothing is posted from now on. In 30 days the workspace and all of its " +
            "data are permanently deleted. Reinstall StandupBot from Slack before then to cancel. If you " +
            "have a paid plan, cancel it in Billing first. Export your data before you confirm if you need it."

    fun deletionScheduledMessage(purgeAfter: Instant): String =
        "Deletion scheduled for ${purgeAfter.toLocalDateTime(TimeZone.UTC).date}"

    fun isRawActivityExpired(
        scheduledFor: Instant,
        now: Instant,
        retentionDays: Int,
    ): Boolean = now - scheduledFor > retentionDays.days

    fun rawActivityExpiredSubtitle(retentionDays: Int): String =
        "Raw activity is kept for $retentionDays days after a standup, so this run's Linear and GitHub " +
            "activity has been removed. The standup text is unchanged."

    fun promptTextRemoved(purgedAt: Instant): String =
        "Prompt and response text was removed on ${purgedAt.toLocalDateTime(TimeZone.UTC).date} under this " +
            "workspace's raw activity retention. Token counts and cost are kept."

    fun summaryRangeNotice(
        from: LocalDate,
        today: LocalDate,
        retentionDays: Int,
    ): String? =
        if (from < today.minus(retentionDays.toLong(), DateTimeUnit.DAY)) {
            "Linear and GitHub counts only cover the last $retentionDays days because raw activity is not " +
                "kept longer. Earlier days show standup text only."
        } else {
            null
        }
}
